var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","hideContacto":_vm.hideContacto,"imContacto":_vm.imContacto,"lang":_vm.lang}},[_c('app-header'),_vm._v(" "),_c('router-view'),_vm._v(" "),(!_vm.imContacto & !_vm.ismovil)?_c('banner-contacto'):_vm._e(),_vm._v(" "),(!_vm.hideContacto)?_c('app-footer'):_vm._e(),_vm._v(" "),_c('popup-bodega')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfecc4d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 